(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8455],{

/***/ 45370:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contact-us",
      function () {
        return __webpack_require__(60886);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 19052:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "e": function() { return /* binding */ CmsModuleList; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(2962);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);





var SingleCoverComponent = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 8821).then(__webpack_require__.bind(__webpack_require__, 88821));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(88821)
            ];
        }
    }
});
var ArticleSnippet = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8574), __webpack_require__.e(370)]).then(__webpack_require__.bind(__webpack_require__, 14649)).then(function(mod) {
        return mod.ArticleSnippet;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(14649)
            ];
        }
    }
});
var CMSButton = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 3877).then(__webpack_require__.bind(__webpack_require__, 33877)).then(function(mod) {
        return mod.CMSButton;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(33877)
            ];
        }
    }
});
var CMSImageText = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(724), __webpack_require__.e(56)]).then(__webpack_require__.bind(__webpack_require__, 80056)).then(function(mod) {
        return mod.CMSImageText;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(80056)
            ];
        }
    }
});
var CMSText = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(724), __webpack_require__.e(4725)]).then(__webpack_require__.bind(__webpack_require__, 4725)).then(function(mod) {
        return mod.CMSText;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(4725)
            ];
        }
    }
});
var CMSVideoText = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(724), __webpack_require__.e(1889)]).then(__webpack_require__.bind(__webpack_require__, 91889)).then(function(mod) {
        return mod.CMSVideoText;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(91889)
            ];
        }
    }
});
var GeneralImageSlider = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(8574), __webpack_require__.e(3654)]).then(__webpack_require__.bind(__webpack_require__, 6655)).then(function(mod) {
        return mod.GeneralImageSlider;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(6655)
            ];
        }
    }
});
var FrequentlyAskedQuestions = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(724), __webpack_require__.e(7074)]).then(__webpack_require__.bind(__webpack_require__, 17074));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(17074)
            ];
        }
    }
});
var CMSForm = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(9669), __webpack_require__.e(807), __webpack_require__.e(9803), __webpack_require__.e(2283), __webpack_require__.e(7243), __webpack_require__.e(4878)]).then(__webpack_require__.bind(__webpack_require__, 31585)).then(function(mod) {
        return mod.CMSForm;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(31585)
            ];
        }
    }
});
var JobSnippet = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return __webpack_require__.e(/* import() */ 3040).then(__webpack_require__.bind(__webpack_require__, 23040)).then(function(mod) {
        return mod.JobSnippet;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(23040)
            ];
        }
    }
});
var Testimonial = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(724), __webpack_require__.e(9708)]).then(__webpack_require__.bind(__webpack_require__, 59708)).then(function(mod) {
        return mod.Testimonial;
    });
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(59708)
            ];
        }
    }
});
var HeroHeaderComponent = next_dynamic__WEBPACK_IMPORTED_MODULE_2___default()(function() {
    return Promise.all(/* import() */[__webpack_require__.e(724), __webpack_require__.e(9685)]).then(__webpack_require__.bind(__webpack_require__, 9685));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(9685)
            ];
        }
    }
});
var ModuleMap = {
    "text-collection": CMSText,
    "image-collection": CMSImageText,
    "cover-collection": SingleCoverComponent,
    "testimonial-collection": Testimonial,
    "faq-collection": FrequentlyAskedQuestions,
    "article-snippet-collection": ArticleSnippet,
    "general-image-slider": GeneralImageSlider,
    "video-collection": CMSVideoText,
    "job-snippet-collection": JobSnippet,
    "button-collection": CMSButton,
    "forms-collection": CMSForm,
    "hero-header-collection": HeroHeaderComponent
};
var renderFaqs = function(modules) {
    var questionAnswers = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = modules[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var item = _step.value;
            if (item.__component !== "faq-collection.faq-collection" || !item.faq_collections) {
                continue;
            }
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = item.faq_collections[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var faq = _step1.value;
                    if (faq.answerPlainText) {
                        questionAnswers.push({
                            questionName: faq.question,
                            acceptedAnswerText: faq.answerPlainText
                        });
                    }
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return questionAnswers.length > 0 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_1__/* .FAQPageJsonLd */ .Mg, {
        mainEntity: questionAnswers
    }) : null;
};
var CmsModuleList = function(param) {
    var modules = param.modules;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            renderFaqs(modules),
            modules.map(function(module) {
                var moduleType = module.__component.split(".")[0];
                var Comp = ModuleMap[moduleType];
                var key = "".concat(module.id, "_").concat(module.__component);
                return Comp ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(Comp, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({}, module), key) : null;
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CmsModuleList);


/***/ }),

/***/ 6673:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Q": function() { return /* binding */ DynamicPage; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _cmsComponents_CmsModuleList__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(19052);
/* harmony import */ var _modules_CMSContainer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77439);
/* harmony import */ var next_seo__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2962);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(22318);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(83030);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_5__);







var DynamicPage = function(param) {
    var data = param.data, pageData = param.pageData;
    var defaultTitle = "Doctor Job Search";
    var defaultDescription = "Discover the right doctor job for you in Australia or New Zealand";
    // The Cover component adds a h1 heading,
    // but no other components do, so we should add one manually
    var thereShouldBeAHeadingAdded = data.length > 0 && data[0].__component !== "cover-collection.single-cover-collection" && data[0].__component !== "hero-header-collection.single-hero-header-collection";
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_modules_CMSContainer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_seo__WEBPACK_IMPORTED_MODULE_3__/* .NextSeo */ .PB, {
                canonical: pageData.canonical_url,
                title: pageData.meta_title || defaultTitle,
                description: pageData.meta_description || defaultDescription,
                noindex: !pageData.index,
                nofollow: !pageData.index,
                openGraph: {
                    title: pageData.meta_title || defaultTitle,
                    description: pageData.meta_description || defaultDescription
                },
                languageAlternates: pageData.language_alternates || []
            }),
            thereShouldBeAHeadingAdded && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_5___default().heading),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    variant: "h3",
                    component: "h1",
                    children: pageData.title
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_cmsComponents_CmsModuleList__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                modules: data
            })
        ]
    });
};
/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ((/* unused pure expression or super */ null && (DynamicPage)));


/***/ }),

/***/ 82898:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "c": function() { return /* reexport */ ProfileBanner; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./modules/LandingHeaderV2/hooks/useUserDisplayInfo.ts
var useUserDisplayInfo = __webpack_require__(43707);
// EXTERNAL MODULE: ./utils/appClientConfig.ts
var appClientConfig = __webpack_require__(77469);
// EXTERNAL MODULE: ./utils/useAnalytics.ts + 2 modules
var useAnalytics = __webpack_require__(9800);
;// CONCATENATED MODULE: ./assets/profileBannerDoctor.png
/* harmony default export */ var profileBannerDoctor = ({"src":"https://cdn.medrecruit.medworld.com/47c66d80968e67b163ad9ebdf45a607c4eaa72df/_next/static/media/profileBannerDoctor.45cf171f.png","height":404,"width":410,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAY1BMVEVMaXESNl+ARiqlbVoEP6N/kLuXteoqVI1jRzqEd4WKXVMGTb89W5hNVHoDWNyqoKpsiL69qafZuKombd2DrvXBtsJxc4uLa2KHcnoXVbi3dE6VVjNja4sDUs6Mi6XE1Pdjl+twEBImAAAAFnRSTlMAGrrsaPz+DGW+08L4/P3++/z+/fBEyeUPCgAAAAlwSFlzAAAWJQAAFiUBSVIk8AAAAEFJREFUCJljYAABFhZ2MM0kLskNotmZpXhkQTQjlzQvHwMDA4cYq4S4MAMDA6cEGxu/AoghxiokLwKSkhGQExQFAESVAoQENAWMAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});
// EXTERNAL MODULE: ./node_modules/classnames/index.js
var classnames = __webpack_require__(93967);
var classnames_default = /*#__PURE__*/__webpack_require__.n(classnames);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(29260);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-cookie-consent/build/index.js
var build = __webpack_require__(92491);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/useMediaQuery/useMediaQuery.js
var useMediaQuery = __webpack_require__(63457);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button = __webpack_require__(282);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/IconButton/IconButton.js
var IconButton = __webpack_require__(17812);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/Close.js
var Close = __webpack_require__(80366);
// EXTERNAL MODULE: ./components/ProfileBanner/ProfileBanner.module.scss
var ProfileBanner_module = __webpack_require__(38948);
var ProfileBanner_module_default = /*#__PURE__*/__webpack_require__.n(ProfileBanner_module);
;// CONCATENATED MODULE: ./components/ProfileBanner/ProfileBanner.tsx














var ProfileBanner = function(param) {
    var cookieConsentOverwrite = param.cookieConsentOverwrite;
    var ref = (0,react.useState)(false), closed = ref[0], setClosed = ref[1];
    var isDesktop = (0,useMediaQuery/* default */.Z)("(min-width: 768px)");
    var track = (0,useAnalytics/* useAnalytics */.z)();
    var isUserLoggedIn = (0,useUserDisplayInfo/* useUserDisplayInfo */.l)().isUserLoggedIn;
    var _practitionerProfileUrl;
    var profileUrl = (_practitionerProfileUrl = appClientConfig/* appClientConfig.practitionerProfileUrl */.p.practitionerProfileUrl) !== null && _practitionerProfileUrl !== void 0 ? _practitionerProfileUrl : "";
    var consent = cookieConsentOverwrite !== null && cookieConsentOverwrite !== void 0 ? cookieConsentOverwrite : (0,build.getCookieConsentValue)();
    if (consent !== "true" || isUserLoggedIn) {
        return null;
    }
    var VariablePill = function() {
        return isDesktop ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                    children: "Top rates,"
                }),
                " negotiated for you"
            ]
        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
            children: "Competitive rates"
        });
    };
    var onBannerClose = function() {
        setClosed(true);
        track("Click", {
            action: "Close profile banner",
            "element text": "",
            "element type": "button"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classnames_default()((ProfileBanner_module_default()).bannerContainer, closed && (ProfileBanner_module_default()).closed),
        role: "banner",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (ProfileBanner_module_default()).imageContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: profileBannerDoctor,
                    priority: true,
                    alt: "",
                    "aria-hidden": true,
                    width: 200,
                    height: 200
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                        className: (ProfileBanner_module_default()).header,
                        children: "Finding your next job just got easier."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: (ProfileBanner_module_default()).subHeader,
                        children: "Register to access"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                        className: (ProfileBanner_module_default()).benefitsPillsList,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Exclusive"
                                    }),
                                    " roles"
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("li", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(VariablePill, {})
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        children: "Jobs"
                                    }),
                                    " matched to you"
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                className: (ProfileBanner_module_default()).getStartedButton,
                variant: "contained",
                href: "".concat(profileUrl, "/sign-up"),
                onClick: function() {
                    return track("Click", {
                        action: "Profile banner - get started",
                        "element text": "Get started",
                        "element type": "button"
                    });
                },
                children: "Get started"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(IconButton/* default */.Z, {
                "aria-label": "close",
                className: (ProfileBanner_module_default()).closeButton,
                onClick: onBannerClose,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Close/* default */.Z, {})
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/ProfileBanner/index.ts



/***/ }),

/***/ 77439:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "I": function() { return /* binding */ CMSContainer; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _app_components_ProfileBanner__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82898);
/* harmony import */ var _modules_LandingHeaderV2__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(22952);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(5152);
/* harmony import */ var next_dynamic__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_dynamic__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(67294);
/* harmony import */ var modules_Footer__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2910);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26152);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_7__);







// import LandingHeader from 'modules/LandingHeader';

var CookieConsentPrompt = next_dynamic__WEBPACK_IMPORTED_MODULE_4___default()(function() {
    return __webpack_require__.e(/* import() */ 1273).then(__webpack_require__.bind(__webpack_require__, 26871));
}, {
    loadableGenerated: {
        webpack: function() {
            return [
                /*require.resolve*/(26871)
            ];
        }
    }
});
var CMSContainer = function(param) {
    var children = param.children, shouldUpdateFooterStyles = param.shouldUpdateFooterStyles;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_7___default().outsideContainer),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_modules_LandingHeaderV2__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {}),
            children,
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(modules_Footer__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                className: classnames__WEBPACK_IMPORTED_MODULE_3___default()(shouldUpdateFooterStyles && (_style_module_scss__WEBPACK_IMPORTED_MODULE_7___default().footer))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CookieConsentPrompt, {}),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_app_components_ProfileBanner__WEBPACK_IMPORTED_MODULE_1__/* .ProfileBanner */ .c, {})
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CMSContainer);


/***/ }),

/***/ 60886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var utils_useAnalytics__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9800);
/* harmony import */ var components_CMS_DynamicPage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(6673);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(91174);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_4__);





var ContactUsLandingPage = function(param) {
    var data = param.data, pageData = param.pageData;
    var track = (0,utils_useAnalytics__WEBPACK_IMPORTED_MODULE_2__/* .useAnalytics */ .z)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var _loop = function(key) {
            var link = elementLinks[key];
            link.element.forEach(function(element) {
                element.addEventListener("click", function(event) {
                    return link.track(event);
                });
            });
        };
        track("ContactUsLandingPage loaded", {});
        var elementLinks = {
            phoneNumber: {
                element: document.querySelectorAll('[href*="tel:"]'),
                track: function(event) {
                    // We need to get the phone number from the anchor link which is `tel:+XXXXX`
                    var phoneNumber = event.target.href.slice(4);
                    track("Contact us via call", {
                        phone_number: phoneNumber
                    });
                }
            },
            emailLink: {
                element: document.querySelectorAll('[href*="mailto:info@medrecruit.com"]'),
                track: function() {
                    return track("Contact us via email", {
                        form_filled: false,
                        email_link: true
                    });
                }
            },
            submitButton: {
                element: document.querySelectorAll('button[type="submit"]'),
                track: function() {
                    return track("Contact us via email", {
                        form_filled: true,
                        email_link: false
                    });
                }
            }
        };
        for(var key in elementLinks)_loop(key);
    });
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_4___default().contactUsLanding),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_CMS_DynamicPage__WEBPACK_IMPORTED_MODULE_3__/* .DynamicPage */ .Q, {
            data: data,
            pageData: pageData
        })
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ContactUsLandingPage);


/***/ }),

/***/ 83030:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"heading":"style_heading__Cf9eC"};

/***/ }),

/***/ 38948:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"bannerContainer":"ProfileBanner_bannerContainer__kQhdF","closed":"ProfileBanner_closed__qtWy_","imageContainer":"ProfileBanner_imageContainer__VFnDG","header":"ProfileBanner_header__oXcWU","subHeader":"ProfileBanner_subHeader__UqIrm","benefitsPillsList":"ProfileBanner_benefitsPillsList__YVD5X","closeButton":"ProfileBanner_closeButton__O17v8","getStartedButton":"ProfileBanner_getStartedButton__dMz_Q"};

/***/ }),

/***/ 26152:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"outsideContainer":"style_outsideContainer__TGLZO","footer":"style_footer__jNdIy","childrenContainer":"style_childrenContainer__ZS__i"};

/***/ }),

/***/ 91174:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"contactUsLanding":"style_contactUsLanding__vkZyW","MuiGrid-spacing-xs-6":"style_MuiGrid-spacing-xs-6__DpU63","MuiGrid-item":"style_MuiGrid-item__rK5Fs"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [2491,5675,9774,2888,179], function() { return __webpack_exec__(45370); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);